import { render } from "./LevelTwo.vue?vue&type=template&id=63d40ca0"
import script from "./LevelTwo.vue?vue&type=script&lang=js"
export * from "./LevelTwo.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__